import { render, staticRenderFns } from "./TimeAllowanceForm.vue?vue&type=template&id=8a7c2042&"
import script from "./TimeAllowanceForm.vue?vue&type=script&lang=js&"
export * from "./TimeAllowanceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports